import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index';
import type { CountryApiResponse } from '@Types/country';

export const fetchCountries = async (includeUSA: boolean, allCountries?: boolean) => {
  const { customerId } = useBoundStore.getState().customer;
  let path = '';
  if (!customerId || allCountries) {
    path = `v3/onboarding/country/?includeUSA=${includeUSA ?? false}`;
  } else {
    path = `v3/onboarding/country/${customerId}/?includeUSA=${includeUSA ?? false}`;
  }
  const { data } = await HttpService.get<CountryApiResponse>(path);
  return data;
};

export const getAllowedCountriesWithoutUSA = {
  queryKey: ['getAllowedCountriesWithoutUSA'],
  queryFn: () => fetchCountries(false, true),
};

export const getAllowedCountries = {
  queryKey: ['getAllowedCountries'],
  queryFn: () => fetchCountries(true, true),
};
